/* External */
import { memo, useMemo } from 'react';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import PropTypes from 'prop-types';
import { List } from 'immutable';

/* Components */
import SearchCardContainer from '../SearchCardContainer';
import ScrollIntoViewIfFocused from '../ScrollIntoViewIfFocused';

/* Utils */
import { noOp } from '../../utils/functions';
import { ScrollPosition } from '../ScrollView';

/* Styles */
import './SearchResults.scss';

function SearchResults({
  searchResults,
  onArrowPress,
  querySearch,
  handleSearchResultTagEvent,
}) {
  const cards = useMemo(() => searchResults.map((searchResult, index) => (
    /* eslint-disable-next-line react/no-array-index-key
        -- Having the id as key lead to navigation bug
           see https://dtvott.atlassian.net/browse/DGD-33840
           TODO: check if there's a better way */
    <ScrollIntoViewIfFocused position={ScrollPosition.CENTER} key={index}>
      <SearchCardContainer
        result={searchResult}
        index={index}
        handleSearchResultTagEvent={handleSearchResultTagEvent}
        querySearch={querySearch}
        onArrowPress={onArrowPress}
      />
    </ScrollIntoViewIfFocused>
  )), [onArrowPress, searchResults, handleSearchResultTagEvent, querySearch]);

  return (
    <div className="dtv-html5-c-search-results">
      {cards}
    </div>
  );
}

SearchResults.propTypes = {
  searchResults: PropTypes.instanceOf(List),
  onArrowPress: PropTypes.func,
  querySearch: PropTypes.string,
  handleSearchResultTagEvent: PropTypes.func,
};

SearchResults.defaultProps = {
  searchResults: [],
  onArrowPress: noOp,
  querySearch: '',
  handleSearchResultTagEvent: noOp,
};

export default memo(withFocusable()(memo(SearchResults)));
